import { Link } from "react-router-dom";
import { Ship, ArrowRight } from "lucide-react";
import { CITIES } from "@/cityConfig";

// Tight "nearby in the Cyclades" cross-link block for the Santorini <-> Mykonos pair.
// Renders only on these two premium Greek island pages and links to the sibling island.
const CYCLADES_PARTNER = {
  santorini: "mykonos",
  mykonos: "santorini",
};

const COPY = {
  santorini: {
    ru: {
      heading: "Рядом на Кикладах",
      body: "Санторини и Миконос — два соседних острова Киклад в паре часов пути друг от друга. Планируете сюрприз сразу на двух островах или переезжаете с Санторини на Миконос? Мы доставляем свежие букеты и на Миконосе — в Хору, Орнос, Псару и к отелям.",
      cta: "Доставка цветов на Миконосе",
    },
    en: {
      heading: "Nearby in the Cyclades",
      body: "Santorini and Mykonos are two neighbouring Cyclades islands just a couple of hours apart. Planning a surprise on both islands or hopping from Santorini to Mykonos? We also deliver fresh bouquets across Mykonos — Chora, Ornos, Psarou and to the hotels.",
      cta: "Flower delivery in Mykonos",
    },
  },
  mykonos: {
    ru: {
      heading: "Рядом на Кикладах",
      body: "Миконос и Санторини — соседние острова Киклад в паре часов пути друг от друга. Планируете сюрприз сразу на двух островах или переезжаете с Миконоса на Санторини? Мы доставляем свежие букеты и на Санторини — в Фиру, Ию, Имеровигли и к отелям на кальдере.",
      cta: "Доставка цветов на Санторини",
    },
    en: {
      heading: "Nearby in the Cyclades",
      body: "Mykonos and Santorini are neighbouring Cyclades islands just a couple of hours apart. Planning a surprise on both islands or hopping from Mykonos to Santorini? We also deliver fresh bouquets across Santorini — Fira, Oia, Imerovigli and to the caldera hotels.",
      cta: "Flower delivery in Santorini",
    },
  },
};

export const CycladesNearbyBlock = ({ citySlug, lang = "ru" }) => {
  const partnerSlug = CYCLADES_PARTNER[citySlug];
  if (!partnerSlug) return null;
  const partner = CITIES[partnerSlug];
  if (!partner) return null;

  const copy = (COPY[citySlug] || {})[lang === "en" ? "en" : "ru"];
  if (!copy) return null;

  const langSuffix = lang !== "ru" ? `?lang=${lang}` : "";

  return (
    <section className="py-12 sm:py-16 bg-[#0b2a3a]" data-testid="cyclades-nearby-block">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 sm:p-10">
          <div className="flex items-center gap-2 text-cyan-300 mb-4">
            <Ship className="w-5 h-5" />
            <span className="text-xs sm:text-sm font-semibold tracking-widest uppercase">
              {copy.heading}
            </span>
          </div>
          <p className="text-white/85 text-base sm:text-lg leading-relaxed mb-6">
            {copy.body}
          </p>
          <Link
            to={`/${partnerSlug}${langSuffix}`}
            className="group inline-flex items-center gap-2 rounded-full bg-white text-[#0b2a3a] px-6 py-3 text-sm sm:text-base font-semibold hover:bg-cyan-200 transition-colors"
            data-testid={`cyclades-partner-link-${partnerSlug}`}
          >
            {copy.cta}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CycladesNearbyBlock;
